import React from "react";
import { Close } from "@mui/icons-material";

const ErrorToast = ({ onClose }) => (
  <>
    {/* Semi-transparent backdrop */}
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        zIndex: 99998,
      }}
      onClick={onClose}
    />
    {/* Centered popup */}
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 99999,
        backgroundColor: "#fff",
        border: "1px solid #e53935",
        borderLeft: "5px solid #e53935",
        borderRadius: "6px",
        boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
        padding: "24px 48px 24px 20px",
        minWidth: "320px",
        maxWidth: "440px",
      }}
    >
      <span style={{ fontSize: "14px", color: "#333" }}>
        Something's wrong, try again.
      </span>
      <button
        onClick={onClose}
        aria-label="Close error notification"
        style={{
          position: "absolute",
          top: "8px",
          right: "8px",
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: "2px",
          color: "#888",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Close style={{ fontSize: "18px" }} />
      </button>
    </div>
  </>
);

export default ErrorToast;
